import React from 'react';
import Cookies from 'universal-cookie';

import { Grid, Row, Col } from 'react-flexbox-grid';

import ActionBar from './ActionBar';
import LoginPage from './LoginPage';
import MainInterface from './MainInterface';

import './App.css';

class App extends React.Component {
  componentWillMount() {
    this.cookies = new Cookies();
    const role = this.cookies.get('icons.user_role') || 'none'

    this.state = {
      isLoggedIn: role === 'none' ? false : true,
      userRole: role,
    };
  }

  handleLogin = () => {
    const role = this.cookies.get('icons.user_role') || 'none'
    if (role === 'none') {
      console.log("Unexpected login behavior.")
      return
    }
    this.setState({
      isLoggedIn: true,
      userRole: role,
    })
  }

  handleLogout = () => {
    const role = this.cookies.get('icons.user_role') || 'none'
    if (role !== 'none') {
      console.log("Unexpected logout behavior.")
      return
    }
    this.setState({
      isLoggedIn: false,
      userRole: role
    })
  }

  render() {
    return (
      <Grid fluid>
        <Row>
          <Col xs={0} md={2}/>
          <Col xs={12} md={8}>
            <ActionBar
              isLoggedIn={this.state.isLoggedIn}
              onLogout={this.handleLogout.bind(this)}
            />
            {this.state.isLoggedIn ? (
              <MainInterface role={this.state.userRole}/>
            ) : (
              <LoginPage onLogin={this.handleLogin.bind(this)}/>
            )}
          </Col>
          <Col xs={0} md={2}/>
        </Row>
      </Grid>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js